//
//  SDKDocsEntityGroupBehavior.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var DocsEntityGroupBehavior;
(function (DocsEntityGroupBehavior) {
    DocsEntityGroupBehavior["group"] = "Group";
    DocsEntityGroupBehavior["tabs"] = "Tabs";
})(DocsEntityGroupBehavior || (DocsEntityGroupBehavior = {}));
